<template>
    <div class="succeed-main">
        <div class="succeed-content">
            <div class="pay-state">
                <img
                    class="pay-icon"
                    src="@/assets/icon/Layer_1.png"
                    alt=""
                />
                <van-skeleton style="width: 100%" title :row="1" :loading="loading">
                    <div class="pay-type">
                        {{ companyInfo.status_format }}
                    </div>
                    <!-- 审核结果将会通过手机短信发送 -->
                    <div class="pay-tz">{{ companyInfo.desc }}</div>
                </van-skeleton>
            </div>
            <!-- 流程 -->
            <div class="process-list-ul">
                <div class="process-list-li">
                    <div class="li-index">01</div>
                    <div class="li-title">支付完成</div>
                </div>
                <div class="process-list-li">
                    <div class="li-index">02</div>
                    <div class="li-title">材料审核</div>
                </div>
                <div class="process-list-li">
                    <div class="li-index">03</div>
                    <div class="li-title">制作寄送</div>
                </div>
            </div>
            <div class="share-to">
                <div class="share-title">分享我的信用到</div>
                <div class="share-img">
                    <div @click="shareFun" class="share-img-text">
                        <img src="@/assets/icon/wxhy-icon.png" alt="" />
                        <span>微信好友</span>
                    </div>
                    <div @click="shareFun" class="share-img-text">
                        <img src="@/assets/icon/pengyouquan-icon.png" alt="" />
                        <span>朋友圈</span>
                    </div>
                </div>
                <div class="share-text">
                    <div class="copy-text">{{ copyText }}</div>
                    <img class="copy-btn" @click="copyFun" src="@/assets/icon/copy-icon.png" alt="" />
                </div>
            </div>
            <aboutUsC />
        </div>
        
        <van-notify v-model="show" type="success">
            <van-icon name="bell" style="margin-right: 4px" />
            <span>请点击右上角 ••• 进行分享</span>
        </van-notify>
    </div>
</template>
<script>
import preventBack from "vue-prevent-browser-back";
import aboutUsC from "@/components/aboutUs";
import { orderInfoApi } from "@/api/index.js";
export default {
    components: {
        aboutUsC,
    },
    mixins: [preventBack],
    data() {
        return {
            loading: true,
            show: false,
            copyText:
                "我已加入优信立信计划，有立信牌匾为证，营造诚实守信良好环境，人人有责",
            payStateText: [
                {
                    state: "材料审核中",
                    inform: "审核结果会手机短信通知",
                },
                {
                    state: "牌匾制作中",
                    inform: "审核结果会手机短信通知",
                },
                {
                    state: "已发货",
                    inform: "快递单号: xxxxxxxxxxxx",
                },
            ],
            payStateIndex: 0,
            cid: "",
            companyInfo: {
                desc: "",
                status_format: "",
            },
        };
    },
    created() {
        this.cid = this.$route.params.cid;
        if (this.cid) {
            this.orderInfoApiFun();
            //微信分享触发事件
            let option = this.util.shareData();
            option.link = `${location.origin}/${this.cid}`;
            // console.log(option)
            this.util.weixinShareFun(option);
        } else {
            this.$toast("企业ID为空");
        }
    },
    methods: {
        orderInfoApiFun() {
            let self = this;
            orderInfoApi(self.cid).then((res) => {
                // console.log(res.data);
                if(res.code == 200){
                    self.companyInfo.desc = res.data.desc;
                    self.copyText = res.data.share_info;
                    self.companyInfo.status_format = res.data.status_format;
                    self.loading = false;
                }else{
                    self.$toast(res.msg || '服务器请求错误')
                }                
            });
        },
        //复制文案
        copyFun() {
            let input = document.createElement("input"); // 创建input对象
            input.value = this.copyText; // 设置复制内容
            document.body.appendChild(input); // 添加临时实例
            input.select(); // 选择实例内容
            document.execCommand("Copy"); // 执行复制
            document.body.removeChild(input); // 删除临时实例
            this.$toast("复制成功");
        },
        //微信分享
        shareFun() {
            if (!this.$store.state.is_weixin_app) return this.$toast("请在微信中打开");
            this.show = true;
            setTimeout(() => {
                this.show = false;
            }, 2000);
        },
    },
};
</script>
<style lang="less" scoped>
.van-skeleton__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 10px;
}
.succeed-main {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url('../../assets/Image/bg.png') no-repeat;
    background-position: top center;  
    background-size: 100% 100%; 
    .succeed-content{
        width: 340px;
        padding-bottom: 30px;
    }
    .pay-state {
        width: 100%;
        height: 174px;
        margin-top: 18px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .pay-icon {
            width: 56px;
            height: 56px;
            margin-top: 17px;
        }
        .pay-type {
            font-size: 26px;
            color: #8B4F19;
            font-weight: 700;
            line-height: 36px;
            margin-top: 5px;
        }
        .pay-tz {
            color: #8B4F19;
            font-size: 14px;
            margin-top: 5px;
        }
    }
    //流程列表
    .process-list-ul{
        margin-top: 15px;
        width: 100%;
        padding: 15px 0;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 14px;
        background-color: #FFFFFF;
        .process-list-li{
            width: calc(100% / 3);
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            z-index: 3;
            .li-index{
                width: 20px;
                height: 20px;
                border-radius: 10px;
                font-size: 11px;
                color: #FFFFFF;
                line-height: 20px;
                text-align: center;
                font-weight: 600;
                background: linear-gradient(to bottom, #603718, #C67132);
            }
            .li-title{
                margin-top: 8px;
                font-size: 13px;
                color: #5E3617;
                line-height: 18px;
            }
        }
        .process-list-li::before{
            content: '';
            width: 100%;
            height: 1px;
            background: #5E3617;
            position: absolute;
            top: 10px;
            left: 50%;                    
            z-index: -1;
        }
        .process-list-li:nth-child(1):before{
            width: 100%;
        }
        .process-list-li:nth-child(2):before{
            width: 50%;
        }
        .process-list-li:nth-child(3):before{
            width: 50%;
            background: #5e361773;
            left: 0; 
        }
        .process-list-li:nth-child(3){
            .li-index{
                background: linear-gradient(to top, #60371873, #C6713273);
            }
            .li-title{
                color: #5e361773;
            }
        }
    }
    .share-to {
        width: 100%;
        margin-top: 17px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 23px;
        border-radius: 14px;
        background-color: #FFFFFF;
        .share-title {
            width: 100%;
            height: 60px;
            font-size: 20px;
            color: #675F54;
            font-weight: 700;
            line-height: 60px;
            text-align: center;
            border-bottom: 1px solid #b69d8b69;
        }
        .share-img {
            width: 160px;
            height: 60px;
            display: flex;
            justify-content: space-between;
            margin-top: 15px;
            margin-bottom: 15px;
            .share-img-text {
                display: flex;
                flex-direction: column;
                align-items: center;               
            }
            img {
                width: 40px;
                height: 40px;
            }
            span{
                margin-top: 5px;
                font-size: 15px;
                color: #333333;
                line-height: 22px;
            }
        }
        .share-text {
            margin-top: 10px;
            margin-bottom: 20px;
            width: 310px;
            background: #FCF6EE;
            border-radius: 8px;
            position: relative;
            padding: 15px;
            box-sizing: border-box;
            .copy-text {
                color: #724529;
                font-size: 14px;
            }
            .copy-btn {
                width: 32px;
                display: block;
                position: absolute;
                right: 0px;bottom: 0px;
                z-index: 3;
            }          
        }
    }
}
</style>